module.exports = __webpack_public_path__ + "img/zhanbao.0cc8555f.png";